/**
 * The alert types the backend raises on an order line — the frontend mirror of
 * `ORDER_LINE_ALERT_TYPES` in `wolsal_base_apis/quotation_line_alert.py`. A type
 * the backend adds has to be listed here before it can be switched off.
 */
export interface IOrderAlertType {
  /** The value the API puts in `IOrderLineAlert.type`. */
  type: string;
  /** The i18n key naming this alert in the settings list. */
  labelKey: string;
}

/**
 * Display order in Settings → Orders → Alerts. The first three reuse the keys the
 * alert modal itself renders, so the list can never word an alert differently from
 * the alert; `quantity_rules` has no single key because the backend picks one per
 * broken rule, and needs its own label.
 */
export const ORDER_LINE_ALERT_TYPES: IOrderAlertType[] = [
  {
    type: 'quantity_exceeded_global_stock',
    labelKey: 'quotations_and_orders.warehouse_stock.quantity_exceeded_global_stock',
  },
  {
    type: 'quantity_exceeded_default_warehouse',
    labelKey: 'quotations_and_orders.warehouse_stock.quantity_exceeded_default_warehouse',
  },
  {
    type: 'quantity_rules',
    labelKey: 'settings.orders_settings.alerts.type.quantity_rules',
  },
  {
    type: 'killing_stock',
    labelKey: 'quotations_and_orders.warehouse_stock.killing_stock',
  },
];
